import * as React from "react";
import Spinner from "react-bootstrap/Spinner";
import Table from "react-bootstrap/Table";
import Form from "react-bootstrap/Form";
import { FieldEntry } from "../../interfaces/FieldEntry";
import ReactPaginate from 'react-paginate';
import { ModuleFieldEntry } from "../../interfaces/ModuleFieldEntry";
import { Config } from "../../App";

interface TableComponentProps {
    moduleFilter: string;
    columnFilter: string;
    wholeWords: boolean;
}

interface TableComponentState {
    fields: ModuleFieldEntry[];
    currentPage: number;
    showEverything: boolean;
}

const ITEMS_PER_PAGE = 250;


export default class ModulesTableComponent extends React.Component<TableComponentProps, TableComponentState> {

    constructor(props: TableComponentProps) {
        super(props);
        this.state = { fields: [], currentPage: 0, showEverything: false };
    }

    componentDidMount() {
        this.GetFields();
    }

    componentWillReceiveProps() {
        this.setState({currentPage: 0});
    }

    private GetFields() {
        fetch(Config().baseName + "/data/module_fields.json")
            .then(resp => resp.json())
            .then(resp => this.setState({ fields: resp }));
    }

    private GetFilteredFields(everything: boolean) {
        const {currentPage, fields} = this.state;
        const {moduleFilter, columnFilter} = this.props;

        //const fields = JSON.parse(JSON.stringify(this.state.fields));

        let newFields = [...fields];
            
        if (moduleFilter) 
            newFields = newFields.filter(field => {
                const {oldModuleName, newModuleName} = field;

                if (!this.props.wholeWords) {
                    if (oldModuleName.toLowerCase().indexOf(moduleFilter.toLowerCase()) !== -1) return true;
                    if (newModuleName.toLowerCase().indexOf(moduleFilter.toLowerCase()) !== -1) return true;
                } else {
                    if (oldModuleName.toLowerCase() === moduleFilter.toLowerCase()) return true;
                    if (newModuleName.toLowerCase() === moduleFilter.toLowerCase()) return true;
                }

                return false;
            });

        if (columnFilter)
            newFields = newFields.filter(field => {
                
                const {oldColumnName, newColumnName, alias} = field;

                if (!this.props.wholeWords) {
                    if (oldColumnName.toLowerCase().indexOf(columnFilter.toLowerCase()) !== -1) return true;
                    if (newColumnName.toLowerCase().indexOf(columnFilter.toLowerCase()) !== -1) return true;
                    if (alias.toLowerCase().indexOf(columnFilter.toLowerCase()) !== -1) return true;
                } else {
                    if (oldColumnName.toLowerCase() === columnFilter.toLowerCase()) return true;
                    if (newColumnName.toLowerCase() === columnFilter.toLowerCase()) return true;
                    if (alias.toLowerCase() === columnFilter.toLowerCase()) return true;
                }

                
                return false;
            });
        
        if (!everything) {
            newFields = [...newFields.slice((currentPage) * ITEMS_PER_PAGE, (currentPage) * ITEMS_PER_PAGE + ITEMS_PER_PAGE)];
        }
        return newFields;
    }

    private showAllWarning() {
        if (!this.state.showEverything) {
            if(confirm("Opravdu chcete zobrazit všechny položky? Akce budou trvat delší dobu.")) {
                this.setState({showEverything: true, fields: []});
                this.GetFields();
            }
        } else {
            this.setState({showEverything: false, fields: []});
            this.GetFields();
        }
    }

    private getState(type: "modified"|"deleted"|"added", isOld: boolean) {
        switch(type) {
            case "modified":
                return <i className="fas fa-highlighter" style={{color: "#3D78E3"}} title="Upraveno"></i>
            case "deleted":
                if (isOld) {
                    return <i className="fas fa-trash" style={{color: "#FA4850"}} title="Smazáno"></i>
                }
                break;
            case "added":
                if (!isOld) {
                    return <i className="fas fa-plus" style={{color: "#34C916"}} title="Přidáno"></i>
                }
                break;
        }
    }

    render() {

        if (this.state.fields.length == 0) {
            return <div className="d-flex flex-column align-items-center mt-3">
                
                <Spinner animation="grow" variant="success" />
                <b>Načítání dat</b>
            </div>
        } else {
            return <>
                <div className="d-flex justify-content-between flex-wrap flex-md-row flex-column">
                    <Form inline className={this.state.showEverything&&"my-3"}>
                        <Form.Group>
                            <Form.Check type="switch" label="Zobrazit vše" id="show-everything" checked={this.state.showEverything} onChange={this.showAllWarning.bind(this)} />
                        </Form.Group>
                    </Form>
                    {!this.state.showEverything&&this.renderPagination()}
                </div>
                <Table className="mt-3" hover striped>
                    <thead>
                        <tr className="table-sticky">
                            <th>Starý modul</th>
                            <th>Nový modul</th>
                            <th>Starý sloupec</th>
                            <th>Alias</th>
                            <th>Nový sloupec</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.GetFilteredFields(this.state.showEverything).map((field, i) => 
                            <tr key={i}>
                                <td>{this.getState(field.moduleNameState, true)} {field.oldModuleName}</td>
                                <td>{this.getState(field.moduleNameState, false)} {field.newModuleName}</td>
                                <td>{this.getState(field.columnNameState, true)} {field.oldColumnName} {field.oldColumnName&&<span>({field.oldColumnType})</span>}</td>
                                <td>{field.alias}</td>
                                <td>{this.getState(field.columnNameState, false)} {field.newColumnName}  {field.newColumnName&&<span>({field.newColumnType})</span>}</td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </>
        }
    }

    private renderPagination() {
        return <ReactPaginate 
            key={this.state.currentPage}
            pageCount={Math.ceil(this.GetFilteredFields(true).length/ITEMS_PER_PAGE)} 
            pageRangeDisplayed={5} 
            marginPagesDisplayed={2} 
            initialPage={this.state.currentPage}
            containerClassName="pagination mb-2 mt-3 pagination-sm"
            pageClassName="page-item"
            pageLinkClassName="page-link"
            activeClassName="page-item active"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            breakClassName="page-item"
            breakLinkClassName="page-link"
            nextLabel="&raquo;"
            previousLabel="&laquo;"
            onPageChange={a => this.setState({currentPage: a.selected})}
            

        />;
    }

}